import {Component, Input, OnInit} from '@angular/core';
import {EquipmentSelectControlService} from '../../services/equipment-select-control.service';
import {EquipmentSelect} from '../../equipment-select.namespace';
import ViewStatus = EquipmentSelect.ViewStatus;
import {EquipmentInterfaces} from '@namespaces/equipment.namespace';

@Component({
    selector: 'app-equipment-full-view',
    templateUrl: 'equipment-full-view.component.html'
})

export class EquipmentFullViewComponent {
    @Input() equipment: EquipmentInterfaces.Model;

    constructor(
        private equipmentSelectControl: EquipmentSelectControlService,
    ) {
    }

    public onSelectClick() {
        this.equipmentSelectControl.setSelectedEquipmentId(+this.equipment.id);
        this.equipmentSelectControl.setSelectedEquipment(this.equipment);
        this.equipmentSelectControl.setViewStatus(ViewStatus.preview);
    }

    public onCancelClick() {
        this.equipmentSelectControl.setViewStatus(ViewStatus.search);
    }
}
